<template>
  <div>
    <mdb-row>
      <mdb-col md="6">
        <label class="form__label">¿Labora actualmente?</label>
        <div  class="form__check">
          <input type="radio" :id="'laboraSi'+index" v-model="work" :value="true" />
          <label :for="'laboraSi'+index">
            <span :class="work ? 'form__label-active' : ''"></span>
            Si
          </label>
        </div>
        <div class="form__check">
          <input type="radio" :id="'laboraNo'+index" v-model="work" :value="false" />
          <label :for="'laboraNo'+index">
            <span :class="!work ? 'form__label-active' : ''"></span>
            No
          </label>
        </div>
      </mdb-col>
        </mdb-row>
    <div v-if="work">
      <mdb-row>
        <mdb-col md="6" sm="8" sx="12" style="margin-bottom: 10px">
          <div class="form__group">
            <label class="form__label">Nombre de la empresa:</label>
            <input type="text" v-model="company" class="form__input" />
            <validation-error :validation="$v.company" />
          </div>
        </mdb-col>
        <mdb-col md="6" sm="8" sx="12" style="margin-bottom: 10px">
          <div class="form__group">
            <label for="input_profesion" class="form__label">Profesión:</label>
            <input type="text" v-model="profession" id="input_profesion" class="form__input" />
              <validation-error :validation="$v.profession" />
          </div>
        </mdb-col>
      </mdb-row>

      <mdb-row>
        <mdb-col md="6" sm="8" sx="12" style="margin-bottom: 10px">
          <div class="form__group">
            <label class="form__label"
              >Puesto:</label
            >
            <input type="text" v-model="companyPosition" class="form__input" />
              <validation-error :validation="$v.companyPosition" />
          </div>
        </mdb-col>
         <mdb-col md="6" sm="8" sx="12" style="margin-bottom: 10px">
          <div class="form__group">
            <label for="input_giro" class="form__label"
                          >Giro de la empresa:</label
                        >
                        <input
                        v-model="businessActivity"
                          type="text"
                          id="input_giro"
                          class="form__input"
                         
                        />
                          <validation-error :validation="$v.businessActivity" />
          </div>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="12"  style="margin-bottom: 10px">
          <div class="form__group">
             <label for="input_direccion" class="form__label"
                          >Dirección de la empresa:</label
                        >
                        <input
                          v-model="addressCompany"
                          type="text"
                          id="input_direccion"
                          class="form__input"
                        />
                          <validation-error :validation="$v.addressCompany" />
          </div>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="6" sm="8" sx="12" style="margin-bottom: 10px">
         <div class="form__group">
          <label class="form__label"
            >Tel. de la empresa o lugar de trabajo:</label
          >
          <input
            type="text"
            v-model="companyPhone"
            class="form__input"
            v-mask="'##########'"
          />
          <validation-error :validation="$v.companyPhone" />
        </div>
      </mdb-col>
      <mdb-col md="6"></mdb-col>
      </mdb-row>
      <mdb-row class="mt-4">
        <mdb-col md="6">
          <label for="buttonUpload" class="form__label"
            >Sube constancia de situación fiscal:</label
          >
          <div v-show="pdfUrl == null" class="curp-upload">
            <label :for="'worker-input' + index" class="btn-label">
              <img
                :src="'/img/icons/upload-document.svg'"
                style="width: 20px"
              />
              SUBIR CONSTANCIA
            </label>

            <input
              type="file"
              accept="application/pdf"
              name="file"
              :id="'worker-input' + index"
              @change="uploadWorker"
            />
            <validation-error :validation="$v.pdfUrl" />
          </div>
          <div v-show="pdfUrl != null" class="input-group">
            <btn
              :text="'¡LISTO!'"
              :type="'primary-admin-success'"
              style="float: left"
            ></btn>

            <img
              style="margin-top: 10px; cursor: pointer"
              :src="'/img/icons/watch-unpressed-btn.svg'"
              @click="viewPdf(pdfUrl)"
              @mouseup="mouseUpIcon('watch')"
              @mousedown="mouseDownIcon('watch')"
              @mouseleave="mouseLeaveIcon('watch')"
            />
          </div>
        </mdb-col>
        <mdb-col md="6"></mdb-col>
      </mdb-row>
    </div>
    <div v-else>
      <mdb-row>
        <mdb-col md="10">
          <label for="input_name" class="form__label">¿A qué se dedica?</label>
          <textarea
          v-model="activityDescription"
            class="form-control"
            rows="5"
            maxlength="150"
            placeholder="Describe a qué se dedica"
            style="font-size: 15px; font-weight: 600; color: #000"
          >
          </textarea>
            <validation-error :validation="$v.activityDescription" />
        </mdb-col>
      </mdb-row>
    </div>

    <Popup size="lg" ref="confirm" title="Carta de situación fiscal">
      <div
        class="embed-responsive embed-responsive-16by9 z-depth-1-half"
        style="height: 75vh"
      >
        <iframe
          title="titulo"
          class="embed-responsive-item"
          :src="popUrl"
          allowfullscreen
        ></iframe>
      </div>
      <div class="accordion__button">
        <btn
          style="float: left"
          text="CERRAR"
          @onClick="$refs.confirm.toggleModal()"
          type="primary-block"
        />
      </div>
    </Popup>
  </div>
</template>
<script>
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import { mdbRow, mdbCol } from "mdbvue";
import Btn from "../../core/Button";
import ValidationError from "../misc/ValidationError";
import { required, requiredIf } from "vuelidate/lib/validators";
import { mask } from "vue-the-mask";
import Popup from "../../core/Popup";

export default {
  name: "childWorkingData",
  props: ["index"],
  components: {
    mdbRow,
    mdbCol,
    Btn,
    ValidationError,
    Popup,
  },
  directives: { mask },
  created() {},
  data() {
    return {
      infoIdIcon: "info-default.svg",
      email: "",
      userAllData: "",
      company:"",
                companyPhone:"",
                companyPosition:"",
                businessActivity:"",
                profession:"",
                addressCompany:"",
                work: true,
                activityDescription: "",
      pdfUrl: null,
      filesPDF: null,
      popUrl: null,
      childrens: [],
    };
  },
  validations: {
    company: {
      required,
    },
    companyPosition: {
      required,
    },
    companyPhone: {
      required,
    },
    pdfUrl: {
      required,
    },
    businessActivity: {
      required
    },
    profession: {
      required
    },
    addressCompany: {
      required
    },
    activityDescription: {
      required
    }
  },
  mounted() {
    this.childrens = this.beneficiaries.filter(function (item) {
      return item.beneficiaryType != "SPOUSE";
    });

    if (this.childrens.length > 0) {
      this.getChildInfo(this.childrens[this.index]);
    }
  },
  methods: {
    getChildInfo(child) {
      var documentTax = child.documents.filter(function (item) {
        return item.documentType == "TAX_STATUS_LETTER";
      });
      this.pdfUrl = documentTax[0].publicURL;
      this.work = child.laborData.working;
      this.profession = child.laborData.profession;
      this.addressCompany = child.laborData.addressCompany;
      this.businessActivity = child.laborData.businessActivity;
      this.activityDescription = child.laborData.activityDescription;
      this.company = child.laborData.company;
      this.companyPhone = child.laborData.phone;
      this.companyPosition = child.laborData.position;;
    },
    chooseFile() {
      document.getElementById("fileUpload").click();
    },
    chooseFileCurp() {
      document.getElementById("fileUploadCurp").click();
    },
    chooseFileColonia() {
      document.getElementById("fileUploadColonia").click();
    },
    chooseFileCartaAntec() {
      document.getElementById("fileUploadCartaAntec").click();
    },
    chooseFileIdentificacion() {
      document.getElementById("fileUploadIdentificacion").click();
    },
    mouseOverIcon() {
      let infoIdIcon = this.infoIdIcon.split("-");
      this.infoIdIcon = `${infoIdIcon[0]}-hover.svg`;
    },
    mouseLeaveIcon() {
      let infoIdIcon = this.infoIdIcon.split("-");
      this.infoIdIcon = `${infoIdIcon[0]}-default.svg`;
    },

    handleAuth() {
      //console.log("handleAuth ...");
    },
    getFormdata() {
       var workingData = [{ laborData: {} }, { documents: {} }];
       if(this.work){
      this.$v.company.$touch();
      this.$v.companyPosition.$touch();
      this.$v.companyPhone.$touch();
      this.$v.businessActivity.$touch();
      this.$v.profession.$touch();
      this.$v.addressCompany.$touch();
      if (!this.$v.company.$invalid && !this.$v.companyPosition.$invalid && !this.$v.companyPhone.$invalid && !this.$v.businessActivity.$invalid && !this.$v.profession.$invalid && !this.$v.addressCompany.$invalid) {
    
        workingData[0].laborData.working = this.work
        workingData[0].laborData.company = this.company
        workingData[0].laborData.phone = this.companyPhone
        workingData[0].laborData.position = this.companyPosition
        workingData[0].laborData.profession = this.profession
        workingData[0].laborData.businessActivity = this.businessActivity
        workingData[0].laborData.addressCompany = this.addressCompany
        workingData[1].documents = {
          documentType: "TAX_STATUS_LETTER",
          value: "",
          extension: "pdf",
          mimeType: "application/pdf",
          content: this.filesPDF,
        };

        return workingData;
      } else {
        return false;
      }
      } else {
        this.$v.activityDescription.$touch();
      if (!this.$v.activityDescription.$invalid) {
          workingData[0].laborData.working = this.work
          workingData[0].laborData.activityDescription = this.activityDescription
       
        return workingData;
      } else {
        return false;
      }
      }
    },
    viewPdf(url) {
      this.popUrl = url;
      this.$refs.confirm.toggleModal();
    },
    uploadWorker: function (evt) {
      this.pdfUrl = URL.createObjectURL(evt.target.files[0]);
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        aux.filesPDF = e.target.result.split(",")[1];
      };
      rdr.readAsDataURL(evt.target.files[0]);
    },
  },
  computed: {
    ...mapGetters({
      beneficiaries: "getBeneficiariesData",
    }),
  },
};
</script>
<style>
.t1-input-colonia {
  /* max-width: 80%; */
  display: inline;
  transform: translateY(3px);
  margin-bottom: 10px !important;
}

.t1-input-curp {
  display: inline;
  max-width: 70%;
  transform: translateY(3px);
}

.t1-input-dia,
.t1-input-mes {
  text-align: center;
  display: inline;
  width: 8%;
  margin-right: 15px;
  transform: translateY(3px);
}

.t1-input-ano {
  text-align: center;
  display: inline;
  width: 12%;
  transform: translateY(3px);
}

.btn-comprobante-domicilio {
  /* margin-left: 10px; */
  display: inline;
}

.btn-acta-nacimiento {
  display: inline-block;
  margin-left: 10px;
}

.btn-upload-curp {
  display: inline;
  margin-left: 10px;
}

.info-icon {
  width: 2rem;
  height: 2rem;
  margin-left: 1rem;
  transition: transform 0.2s;
}

.info-icon:hover {
  transform: scale(1.3);
}

@media (max-width: 1199px) {
  .t1-input-curp {
    display: block;
    max-width: 100%;
    transform: translateY(3px);
  }

  .t1-input-dia,
  .t1-input-mes {
    width: 12%;
  }

  .t1-input-ano {
    width: 18%;
  }

  .btn-upload-curp {
    display: block;
    margin-top: 10px;
    margin-left: 0px;
  }

  .btn-acta-nacimiento {
    display: block;
    margin-left: 0px;
    margin-top: 10px;
  }
}

@media (max-width: 992px) {
  .btn-comprobante-domicilio {
    margin-left: 0px;
    display: block;
  }

  .t1-input-dia,
  .t1-input-mes {
    width: 18%;
  }

  .t1-input-ano {
    width: 28%;
  }

  .t1-input-colonia {
    max-width: 100%;
    margin-bottom: 10px;
    display: block;
  }
}

@media (max-width: 768px) {
  .t1-input-colonia {
    max-width: 100%;
  }
}

@media (max-width: 576px) {
}
</style>